import type {RouteRecordRaw} from 'vue-router';
import {resolveRuleFormComponent} from './resolveRuleFormComponent';
import {noOrderManagementGuard} from '../guards/order-management-guard';

export const shopSettingsShipmentRoutes: RouteRecordRaw[] = [
  {
    path: 'shipment',
    name: 'shop-settings-shipment',
    component: () => import('@/views/Settings/Shop/Shipment/ShipmentSettingsIndex.vue'),
    meta: {
      permissions: ['selectApiKey', 'selectWebhookSubscription', 'updateShopGeneralSettings'],
      title: (t) => t('shipment.index.shipment', 2),
      titleBarHeader: (t) => t('shipment.index.shipment', 2),
    },
    children: [
      {
        path: '',
        name: 'shop-settings-labels',
        components: {
          shipmentSettings: () => import('@/views/Settings/Shop/Shipment/General/General.vue'),
        },
      },
      {
        path: 'rules',
        children: [
          {
            path: '',
            name: 'shop-settings-shipping-rules',
            components: {
              shipmentSettings: () => import('@/views/Settings/Shop/Shipment/ShippingRules/ShippingRules.vue'),
            },
            beforeEnter: noOrderManagementGuard,
            meta: {
              title: (t) => t('rules.shippingRule', 2),
            },
          },
          {
            path: 'create',
            name: 'shop-settings-shipping-rules-create',
            components: {
              shipmentSettings: resolveRuleFormComponent(
                () =>
                  import('@/views/Settings/Shop/Shipment/ShippingRules/ShippingRuleCreateLegacy/ShippingRuleCreateLegacy.vue'),
              ),
            },
            meta: {
              title: (t) => t('rules.legacy.shipping.create'),
              titleBarHeader: 'rules.legacy.shipping.create',
              hasTabMenu: false,
              rootRouteName: 'shop-settings-shipping-rules',
              activeRouteNameAliases: ['shop-settings-shipping-rules'],
            },
          },
          {
            path: ':ruleId',
            name: 'shop-settings-shipping-rules-edit',
            props: true,
            components: {
              shipmentSettings: resolveRuleFormComponent(
                () =>
                  import('@/views/Settings/Shop/Shipment/ShippingRules/ShippingRuleEditLegacy/ShippingRuleEditLegacy.vue'),
              ),
            },
            meta: {
              title: (t) => t('rules.legacy.shipping.edit'),
              titleBarHeader: 'rules.legacy.shipping.edit',
              hasTabMenu: false,
              rootRouteName: 'shop-settings-shipping-rules',
              activeRouteNameAliases: ['shop-settings-shipping-rules'],
            },
          },
        ],
      },
      {
        path: 'carriers',
        name: 'shop-settings-carriers',
        components: {
          shipmentSettings: () => import('@/views/Settings/Shop/Shipment/Carriers/Carriers.vue'),
        },
      },
      {
        path: 'dimensions-presets',
        children: [
          {
            path: '',
            name: 'shop-settings-dimensions-presets',
            components: {
              shipmentSettings: () =>
                import('@/views/Settings/Shop/Shipment/DimensionsPresets/DimensionsPresetsOverview.vue'),
            },
            meta: {
              title: (t) => t('settings.shop.shipments.dimensionsPresets.title'),
              hasTabMenu: true,
            },
          },
          {
            path: 'create',
            name: 'shop-settings-dimensions-presets-create',
            components: {
              shipmentSettings: () =>
                import('@/views/Settings/Shop/Shipment/DimensionsPresets/DimensionsPresetCreate.vue'),
            },
            meta: {
              title: (t) => t('settings.shop.shipments.dimensionsPresets.create'),
              titleBarHeader: 'settings.shop.shipments.dimensionsPresets.create',
              hasTabMenu: false,
              activeRouteNameAliases: ['shop-settings-dimensions-presets'],
            },
          },
          {
            path: ':id',
            name: 'shop-settings-dimensions-presets-edit',
            props: true,
            components: {
              shipmentSettings: () =>
                import('@/views/Settings/Shop/Shipment/DimensionsPresets/DimensionsPresetEdit.vue'),
            },
            meta: {
              title: (t) => t('settings.shop.shipments.dimensionsPresets.edit'),
              titleBarHeader: 'settings.shop.shipments.dimensionsPresets.edit',
              hasTabMenu: false,
              activeRouteNameAliases: ['shop-settings-dimensions-presets'],
            },
          },
        ],
      },
    ],
  },
];
